"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const CrownIcon = createSVGIcon(
  <>
    <path
      d="M16.8813 6.56127L11.9981 0L7.11874 6.56127L0 3.87466L2.78374 17H21.2163L24 3.87466L16.8813 6.56127Z"
      fill="currentColor"
    />
  </>,
  "CrownIcon",
  {
    viewBox: "0 -3 24 24",
    width: "24",
    height: "24",
    color: "#29A7B8",
  }
);

export const CircledCrownIcon = createSVGIcon(
  <>
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      stroke="currentColor"
    />
    <path
      d="M14.5569 11.1044L11.9991 7.42859L9.44322 11.1044L5.71436 9.59926L7.1725 16H16.8276L18.2858 9.59926L14.5569 11.1044Z"
      stroke="currentColor"
      fill="white"
    />
  </>,
  "CircledCrownIcon",
  {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "none",
  }
);

export const DashedCircledCrownIcon = createSVGIcon(
  <>
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      stroke="currentColor"
      strokeDasharray="2 2"
    />
    <path
      d="M14.5569 11.1044L11.9991 7.42859L9.44322 11.1044L5.71436 9.59926L7.1725 16H16.8276L18.2858 9.59926L14.5569 11.1044Z"
      fill="currentColor"
    />
  </>,
  "DashedCircledCrownIcon",
  {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "none",
  }
);
